export default __webpack_public_path__ + "static/media/Royal Dragon Elite Legguards.546b27d4.jpg";